<template>
  <header class="site-header">
    <div class="header-inner">
      <div class="logo">
        <a href="https://www.cityu.edu.hk/upress" target="_blank" rel="noopener noreferrer">
          <img src="../assets/images/logo-title.png" alt="" />
        </a>
      </div>
      <nav class="main-nav">
        <router-link to="/">{{ $t("nav.home") }}</router-link>
        <router-link to="/explore" class="nav-explore">{{
          $t("nav.explore")
        }}</router-link>
        <!-- <router-link to="/open-access" class="nav-open">{{
          $t("nav.openAccess")
        }}</router-link> -->
        <router-link to="/about">{{ $t("nav.about") }}</router-link>
        <el-dropdown @command="handleLangCommand" trigger="click">
          <span class="lang-btn">
            {{ currentLangLabel }}
            <img src="../assets/images/icon-down.png" alt="" class="lang-arrow" />
          </span>
          <el-dropdown-menu slot="dropdown" class="lang-dropdown">
            <el-dropdown-item command="zh" :class="{ 'is-active': $i18n.locale === 'zh' }">繁體</el-dropdown-item>
            <el-dropdown-item command="en" :class="{ 'is-active': $i18n.locale === 'en' }">EN</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "SiteHeader",
  computed: {
    currentLangLabel() {
      return this.$i18n.locale === "zh" ? "繁" : "EN";
    },
  },
  methods: {
    toggleLang() {
      this.$i18n.locale = this.$i18n.locale === "zh" ? "en" : "zh";
    },
    handleLangCommand(command) {
      this.$i18n.locale = command;
    },
  },
};
</script>

<style lang="scss" scoped>
.site-header {
  background: $white;
  border-bottom: 1px solid $border-color;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-inner {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  padding: 6px 24px;
}

.logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;

  img {
    height: 100px;
    width: auto;
    max-width: 100%;
    display: block;
  }
}

.logo-text {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.logo-cn {
  font-size: 14px;
  font-weight: 700;
  color: $text-dark;
}

.logo-en {
  font-size: 11px;
  color: $text-gray;
}

.main-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 32px;

  a {
    font-size: 16px;
    color: $text-dark;
    transition: color 0.2s;
    white-space: nowrap;

    &:hover,
    &.router-link-exact-active {
      color: $primary-orange;
    }
  }
}

.lang-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(254, 240, 221, 0.75);
  border: 1px solid #ffe0b7;
  border-radius: 5px;
  padding: 4px 10px;
  font-size: 16px;
  color: $text-dark;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;

  &:hover {
    background: rgba(254, 240, 221, 1);
  }

  .lang-arrow {
    width: 10px;
    height: auto;
    margin-left: 2px;
  }
}
</style>
<style lang="scss">
.lang-dropdown.el-dropdown-menu {
  min-width: 80px;
  border-radius: 6px;
  border: 1px solid #ffe0b7;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 4px 0;

  .el-dropdown-menu__item {
    font-size: 14px;
    color: $text-dark;
    padding: 8px 16px;
    line-height: 1.4;

    &:hover,
    &:focus {
      background-color: $bg-orange-light;
      color: $primary-orange;
    }

    &.is-active {
      color: $primary-orange;
      font-weight: 600;
    }
  }

  &.el-popper[x-placement^="bottom"] .popper__arrow::after {
    border-bottom-color: #fff;
  }

  &.el-popper[x-placement^="bottom"] .popper__arrow {
    border-bottom-color: #ffe0b7;
  }
}
</style>